import { app } from '../../../app';

app.component('sessionExpired', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./session-expired.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/session-expired/session-expired.component.js